import { OdataManager } from '@/api/odata/odata-manager';
import { Paragraph } from '@/api/model/interfaces';

export default class ParagraphOdata extends OdataManager<Paragraph> {}
